import {DictionaryCode} from '../../enums/dictionary-code.enum';

export namespace DictionaryActions {
    export class Download {
        static readonly type = 'DictionaryActions.Download';

        constructor(public codes: DictionaryCode | DictionaryCode[]) {
        }
    }
}
